// import { Message } from 'element-ui';
import Message from 'utils/OnceMessage';
import Codes from './codes';
import Login from '../utils/login';
import getCurrentLoginRole from '../utils/currentLoginRole';
import ROLES from '../utils/roles';
import _axios from 'axios';
import GETS from './apis.get';
import POSTS from './apis.post';
import DELETES from './apis.delete';
import PUTS from './apis.put';
import store from '../store';
import { mapApiErrorMsg } from './errorMsgI18n';
import Plat from '../utils/plat';
// import { URL_KEYS } from '../constants/role';
import CACHE_APIS from './caches';
_axios.defaults.baseURL = process.env.VUE_APP_API_BASE;
_axios.defaults.headers.post['Content-Type'] = 'application/json';
const MAX_RECALL_TIMES = 3; // 上传错误允许重传次数

function showApiErrorMsg(msg) {
  if (!msg || msg === '') {
    return;
  }
  Message.error({
    message: mapApiErrorMsg(msg)
  });
}
/**
 * @description 根据地址获取对应角色token
 * @function getCurrentToken
 * @param {String} url url地址
 * @return {String} 对应角色token
 */
const getCurrentToken = url => {
  const role = getCurrentLoginRole();
  if (!role) {
    return undefined;
  }
  return `Bearer ${localStorage.getItem(`${role}_TOKEN`)}`;
};
/**
 * @description 针对restapi地址带参重写api地址
 * @function getApiUrl
 * @param {String} api api地址
 * @param {Object} config api配置对象
 * @return {String} 带参后的地址
 */
const getApiUrl = (api, config) => {
  let url = api;
  if (url.match(/{\d}/) && config.src && config.src.length) {
    config.src.forEach(item => {
      url = url.replace(/{\d}/, item);
    });
  }
  return url;
};
export class Axios {
  constructor() {
    this.axios = _axios.create();
    this.ossAxios = _axios.create();
    this.get = {};
    this.post = {};
    this.delete = {};
    this.put = {};
    this.initInterceptors();
    this.initOSSInterceptors();
    this.initial();
  }
  setPlatHeader() {
    let plat = 'web';
    if (Plat.isMiniProgram()) {
      plat = 'wechatweb';
    } else if (Plat.isWeiXin()) {
      plat = 'wechat';
    }
    this.axios.defaults.headers.common['x-plat'] = plat;
  }
  setAxiosDefaultToken(url, config) {

    if (config?.token) {
      this.axios.defaults.headers.common['Authorization'] = `Bearer ${config.token}`;
    } else {
      this.axios.defaults.headers.common['Authorization'] = getCurrentToken(url);
    }
    this.setPlatHeader();
  }
  factory(type, api) {
    switch (type) {
      case 'GET': {
        return (params, config = {}) => {
          config.params = params;
          const url = getApiUrl(api, config);
          this.setAxiosDefaultToken(url, config);
          return new Promise((resolve, reject) => {
            let cacheObj = CACHE_APIS.find(item => item.api === api);
            if (cacheObj && window[cacheObj.key]) {
              // console.log('match cache');
              resolve(window[cacheObj.key]);
            } else if (cacheObj && window[cacheObj.key + '|during']) {
              // console.log('waiting cache');
              let waiting = setInterval(() => {
                let res = window[cacheObj.key];
                if (res) {
                  // console.log('get cache');
                  resolve(res);
                  clearInterval(waiting);
                }
              }, 200);
            } else {
              if (cacheObj) {
                // console.log('query');
              }
              if (cacheObj && !window[cacheObj.key + '|during']) {
                window[cacheObj.key + '|during'] = true;
              }
              this.axios
                .get(url, config)
                .then(res => {
                  if (cacheObj) {
                    window[cacheObj.key] = res.data;
                    window[cacheObj.key + '|during'] = false;
                  }
                  resolve(res.data);
                })
                .catch(err => {
                  reject(err);
                });
            }
          });
        };
      }
      case 'POST': {
        return (data, config) => {
          let url = getApiUrl(api, config);
          this.setAxiosDefaultToken(url, config);
          return new Promise((resolve, reject) => {
            this.axios
              .post(url, data, config)
              .then(res => {
                resolve(res.data);
              })
              .catch(err => {
                reject(err);
              });
          });
        };
      }
      case 'PUT': {
        return (data, config) => {
          let url = getApiUrl(api, config);
          this.setAxiosDefaultToken(url, config);
          return new Promise((resolve, reject) => {
            this.axios
              .put(url, data, config)
              .then(res => {
                resolve(res.data);
              })
              .catch(err => {
                reject(err);
              });
          });
        };
      }
      case 'DELETE': {
        return (data, config) => {
          config.params = data;
          let url = getApiUrl(api, config);
          this.setAxiosDefaultToken(url, config);
          return new Promise((resolve, reject) => {
            this.axios
              .delete(url, config)
              .then(res => {
                resolve(res.data);
              })
              .catch(err => {
                reject(err);
              });
          });
        };
      }
    }
  }
  initial() {
    for (let api in GETS) {
      this.get[api] = this.factory('GET', GETS[api]);
    }
    for (let api in POSTS) {
      this.post[api] = this.factory('POST', POSTS[api]);
    }
    for (let api in DELETES) {
      this.delete[api] = this.factory('DELETE', DELETES[api]);
    }
    for (let api in PUTS) {
      this.put[api] = this.factory('PUT', PUTS[api]);
    }
  }
  postOSS(credentialRes, file, count = 0) {
    let formData = new FormData();
    if (credentialRes) {
      formData.append('key', credentialRes.key);
      formData.append('policy', credentialRes.policy);
      formData.append('signature', credentialRes.signature);
      formData.append('OSSAccessKeyId', credentialRes.access_id);
      formData.append('success_action_status', Codes.SUCCESS);
      formData.append('file', file);
    }
    return new Promise((resolve, reject) => {
      this.ossAxios({
        url: credentialRes.endpoint,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log('catch', err);
          reject(err);
        });
    })
      .then(res => {
        return Promise.resolve(res);
      })
      .catch(err => {
        if (count < MAX_RECALL_TIMES - 1) {
          console.log(`OSS第${count + 1}次发送失败`, err);
          count++;
          return this.postOSS(credentialRes, file, count);
        } else {
          Message.error({
            message: '系统错误，请联系管理员！'
          });
          return Promise.resolve(err);
        }
      });
  }
  postForm(formData, url, headers) {
    return new Promise((resolve, reject) => {
      this.axios({
        url: url,
        method: 'post',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: getCurrentToken(url),
          ...headers
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  initInterceptors() {
    this.axios.interceptors.response.use(
      response => {
        if (response.status.toString() === Codes.SUCCESS && !response.data.status) {
          return response;
        } else {
          let status = response.data.status;
          // let guards = response.data.guards;
          if (status === Codes.SUCCESS) {
            return response;
          } else if (status === Codes.AUTH_ERR) {
            console.log('Must Login!');
            response.data.msg = '请重新登录！';
            Login.setLogout();
            let pathName = window.location.pathname;
            let href = window.location.pathname + encodeURIComponent(window.location.search);
            let path = '/register';
            // console.log(guards);
            // if (guards && guards.indexOf('teacher') > -1) {
            //   path = '/login';
            // } else if (guards && guards.indexOf('admin') > -1) {
            //   path = '/admin-login';
            // } else {
            //   path = '/login';
            // }
            if (pathName.indexOf('login') < 0 && pathName.indexOf('register') < 0) {
              if (response?.config?.url.indexOf('/api/student/house/') > -1) {
                window.location.href = `${path}?r=${href}`;
              } else {
                window.location.href = `${path}?r=${href}`;
              }
            }
          } else if (status === Codes.REDIRECTION) {
            showApiErrorMsg(response.data.msg);
            setTimeout(() => {
              window.location.href = response.data.url;
            }, 1000);
          } else if (status === Codes.REFREASH) {
            showApiErrorMsg(response.data.msg);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else if (status === Codes.BACKTOAST) {
            showApiErrorMsg(response.data.msg);
            setTimeout(() => {
              window.history.back();
            }, 1000);
          }
          if (status === Codes.ERR_MSG) {
            showApiErrorMsg(response.data.msg);
          }
          return response;
        }
      },
      error => {
        /**
         * @description 判断是否为跳转引起的请求断开
         * 当页面跳转时，正在进行的请求会被浏览器取消，此时应忽略toast提示
         * 跳转导致的请求断开通常表现为：Network Error 且没有 response
         */
        const isCanceledRequest =
          error.code === 'ERR_CANCELED' ||
          (error.message === 'Network Error' && !error.response) ||
          (error.message && error.message.toLowerCase().includes('cancel')) ||
          (!error.response && error.request && error.request.readyState === 0);

        if (!isCanceledRequest) {
          Message.error({
            message: '系统错误，请联系管理员！'
          });
        }
        console.log('Ajax error! Following is messages:');
        console.log('Request:', error.request);
        console.log('Response:', error.response);
        console.log('Error:', error);
        return Object.assign({ status: Codes.ERR }, { data: error });
      }
    );
  }
  initOSSInterceptors() {
    this.ossAxios.interceptors.response.use(
      response => {
        if (response.status.toString() === Codes.SUCCESS && !response.data.status) {
          return response;
        } else {
          let status = response.data.status;
          // let guards = response.data.guards;
          if (status === Codes.SUCCESS) {
            return response;
          } else if (status === Codes.AUTH_ERR) {
            console.log('Must Login!');
            response.data.msg = '请重新登录！';
            Login.setLogout();
            let pathName = window.location.pathname;
            let href = window.location.pathname + encodeURIComponent(window.location.search);
            let path = '/login';
            // console.log(guards);
            // if (guards && guards.indexOf('teacher') > -1) {
            //   path = '/login';
            // } else if (guards && guards.indexOf('admin') > -1) {
            //   path = '/admin-login';
            // } else {
            //   path = '/login';
            // }
            if (pathName.indexOf('login') < 0) {
              window.location.href = `${path}?r=${href}`;
            }
          } else if (status === Codes.REDIRECTION) {
            showApiErrorMsg(response.data.msg);
            setTimeout(() => {
              window.location.href = response.data.url;
            }, 1000);
          } else if (status === Codes.ERR_MSG) {
            showApiErrorMsg(response.data.msg);
          }
          return response;
        }
      },
      error => {
        // return Object.assign({ status: Codes.ERR }, { data: error });
        return Promise.reject({ status: Codes.ERR }, { data: error });
      }
    );
  }
}
export default new Axios();
